import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import RearrangePDFPagesImagesListScreen from "./RearrangePDFPagesImagesListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function RearrangePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Rearrange PDF Pages Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/rearrange_pdf", title: "Organize PDF Files Online" },
    data2: { link: "/rearrange_pdf", title: "Rearrange PDF Pages Online" },
    data3: { link: "/rearrange_pdf", title: "Change PDF Pages Order" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Rearrange PDF pages online easily. Reorder, move, and organize PDF pages quickly with our fast, secure, and simple PDF rearrange tool."
      ></meta>
      <meta
        name="keywords"
        content="rearrange pdf, reorder pdf pages, organize pdf pages, pdf page organizer, move pdf pages, rearrange pdf online, pdf editor online, reorder pdf online, pdf management tool, sort pdf pages, change pdf page order, pdf page editor, rearrange pdf files, organize pdf online, pdf document organizer"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <RearrangePDFPagesImagesListScreen
          title={title}
        ></RearrangePDFPagesImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Rearrange PDF Pages website offers a fast, secure, and flexible solution to organize and reorder PDF documents both offline and online. Designed for students, professionals, and businesses, this powerful tool allows you to rearrange PDF pages, move, swap, rotate, and reorder pages with complete control while preserving the original document quality. With offline functionality, all processing happens directly on your device, ensuring maximum privacy and data security without uploading files to external servers. When internet access is available, users can easily rearrange PDF pages online through a smooth, browser-based interface for instant results. Whether you need to organise PDF pages, merge content logically, or change PDF pages order for reports, contracts, assignments, or presentations, this tool delivers accurate and professional output. The platform also supports organise PDF pages online, making it convenient to manage documents from any device. Using advanced page-handling technology, the tool maintains original formatting, text clarity, and image quality while rearranging pages. Compatible with desktop and mobile devices, this website helps users organize PDFs efficiently, improve document readability, and streamline workflows. If you are searching for the best tool to rearrange PDF pages, rearrange PDF pages online, organise PDF pages, organise PDF pages online, reorder pdf pages or change PDF pages order securely and quickly, this platform provides a complete, user-friendly PDF management solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Arrange",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Rearrange PDF Pages Tool"
            why_use={[
              {
                title: "Organize PDF Pages in the Correct Order",
                description:
                  "PDF files created from multiple sources often have incorrect page order. Our rearrange PDF pages tool helps organize content logically and professionally.",
              },
              {
                title: "Change PDF Pages Order Easily",
                description:
                  "Instead of recreating documents, you can quickly change PDF pages order using a simple and efficient rearrange PDF pages feature.",
              },
              {
                title: "Improve Document Readability",
                description:
                  "Proper page sequence improves document flow and clarity. Tools to organise PDF pages online help create easy-to-read and well-structured PDFs.",
              },
              {
                title: "Rearrange PDF Pages Online Anytime",
                description:
                  "With rearrange PDF pages online, users can manage and reorder PDF files from any device without installing heavy software.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "Our offline tool allows you to rearrange PDF pages securely without uploading files, ensuring complete data privacy.",
              },
              {
                title: "Create Professional-Looking Documents",
                description:
                  "Well-organized PDFs look more professional. Using tools to organise PDF pages helps prepare reports, contracts, and presentations.",
              },
              {
                title: "Simplify Editing and Collaboration",
                description:
                  "Reordering pages makes collaboration easier. Rearrange PDF pages online tools help teams review and finalize documents faster.",
              },
              {
                title: "Fix Scanning and Merging Errors",
                description:
                  "Scanned or merged PDFs often have mixed-up pages. A change PDF pages order tool quickly corrects these issues.",
              },
              {
                title: "Save Time in Document Workflows",
                description:
                  "Instead of manually editing content, you can organise PDF pages online in seconds, improving productivity.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is a PDF page rearranger?",
                description:
                  "A PDF page rearranger is a tool that lets you change the order of pages in a PDF document. You can organize pages into a more logical sequence without recreating the entire document.",
              },
              {
                title: "How can I rearrange PDF pages for free?",
                description:
                  "Use the PDF rearranging tool on ShivaPDF.com to organize your document's pages. Add your PDF, arrange the pages in your preferred order, and save the updated file if these features are supported by the tool.",
              },
              {
                title: "Can I rearrange PDF pages offline?",
                description:
                  "Yes, if the tool supports offline processing, you can rearrange PDF pages without an active internet connection after the page and required resources have loaded. Confirm that offline processing is supported by the current implementation.",
              },
              {
                title: "Does ShivaPDF upload my PDF when I rearrange pages?",
                description:
                  "A locally processed PDF rearranger can organize pages directly in your browser without sending the document to a server. Check the tool's implementation and privacy policy to confirm whether your PDF stays on your device.",
              },
              {
                title: "How do I change the order of pages in a PDF?",
                description:
                  "Open the PDF rearranging tool, select your document, and move the pages into the desired sequence using the available page controls. Then apply the changes and save the rearranged PDF.",
              },
              {
                title: "Can I move a page from the beginning to the end of a PDF?",
                description:
                  "Yes. A PDF page rearranger lets you move a page from the beginning, middle, or end of a document to another position. Place the page where you want it in the sequence before saving the file.",
              },
              {
                title: "Can I rearrange multiple PDF pages at once?",
                description:
                  "Depending on the tool's controls, you may be able to move several pages into a new order or organize them one at a time. Review the page arrangement before saving to ensure the document follows your intended sequence.",
              },
              {
                title: "Can I rearrange PDF pages on my phone?",
                description:
                  "You can rearrange PDF pages on a compatible iPhone or Android device using a mobile-friendly browser-based tool. Open ShivaPDF.com, select the PDF, and use the available page arrangement controls.",
              },
              {
                title: "Can I rearrange PDF pages on a Mac or Windows computer?",
                description:
                  "Yes, a browser-based PDF rearranger can work on compatible Mac and Windows computers. Open the tool in your browser and select the PDF you want to organize.",
              },
              {
                title: "Can I rearrange pages in a large PDF file?",
                description:
                  "Handling large PDFs depends on the available memory, browser, device, and tool limits. For smoother processing, close unnecessary applications and use a device with enough available memory.",
              },
              {
                title: "Can I rearrange PDF pages without changing their content?",
                description:
                  "Rearranging pages changes their sequence rather than intentionally editing the text or images on each page. Review the saved PDF to confirm that its content and layout remain as expected.",
              },
              {
                title: "Will rearranging PDF pages affect formatting?",
                description:
                  "Changing page order should not intentionally alter the formatting of individual pages. However, always review the output to make sure the document displays correctly and all pages appear in the intended order.",
              },
              {
                title: "Can I rearrange a scanned PDF?",
                description:
                  "Yes, scanned PDFs can generally be rearranged because each scanned page is usually stored as a page containing an image. The document does not necessarily need selectable text for its pages to be reordered.",
              },
              {
                title: "Can I rearrange a password-protected PDF?",
                description:
                  "A password-protected PDF may need to be unlocked before its pages can be rearranged. You must have the required password and permission to modify the document.",
              },
              {
                title: "Can I rearrange PDF pages and keep the original file?",
                description:
                  "Yes, you can keep your original PDF by saving the rearranged document as a separate file when the tool offers that option. This lets you retain the original page order for future reference.",
              },
              {
                title: "Can I rearrange PDF pages without installing software?",
                description:
                  "A browser-based PDF rearranger lets you organize pages without installing a separate desktop application. Open ShivaPDF.com in a compatible browser and use the available PDF tool.",
              },
              {
                title: "Is ShivaPDF's PDF rearranger free?",
                description:
                  "ShivaPDF offers online PDF tools intended to make document tasks easier. Check the rearranging tool's page for current availability, file-size limits, and any usage restrictions.",
              },
              {
                title: "Can I rearrange PDF pages without creating an account?",
                description:
                  "A PDF rearranging tool can be used without registration if account creation is not required. Check the current ShivaPDF tool page for its access and usage requirements.",
              },
              {
                title: "Why can't I rearrange pages in my PDF?",
                description:
                  "The PDF may be password-protected, damaged, unusually large, or incompatible with the tool. Try opening a valid copy, checking document permissions, or using a smaller PDF to identify the issue.",
              },
              {
                title: "How do I save a PDF after rearranging its pages?",
                description:
                  "After arranging the pages, use the tool's apply, process, or download option to save the updated PDF. Open the downloaded file and check that every page appears in the correct order.",
              },
              {
                title: "Can I rearrange PDF pages for printing?",
                description:
                  "Yes. Rearranging pages before printing helps put chapters, forms, reports, and other documents in the correct sequence. Save the updated PDF and review the page order before printing.",
              },
              {
                title: "Can I organize PDF pages in numerical order?",
                description:
                  "Yes. You can arrange pages into a numerical or logical sequence using the page arrangement controls. This is useful for scanned documents, reports, invoices, assignments, and merged PDFs.",
              },
              {
                title: "Is it safe to rearrange confidential PDF documents online?",
                description:
                  "For sensitive documents, choose a tool with a clear privacy policy and verified local processing if keeping files on your device is important. Avoid uploading confidential information to services unless you understand how it is handled.",
              },
              {
                title: "Why should I use ShivaPDF to rearrange PDF pages?",
                description:
                  "ShivaPDF provides browser-based PDF tools for common document tasks. Its PDF rearranging tool can help you organize pages into the desired order without needing a dedicated desktop PDF editor, depending on the features available.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default RearrangePDFMain;
